String.prototype.firstChar = function () {
  if (this.length === 0) {
    return "";
  }

  return this.substring(0, 1);
};
String.prototype.toFriendlyStatus = function () {
  switch (this.toUpperCase().trim()) {
    case "A":
      return "Active";

    case "C":
      return "Completed";
    case "X":
      return "Cancelled";

    case "D":
      return "Draft";

    case "P":
      return "Pending";

    case "L":
      return "Locked";

    case "N":
      return "New";

    case "Open":
      return "Open";

    case "Paid":
      return "Paid";

    case "Overdue":
      return "Overdue";

    case "Allocated":
      return "Allocated";

    case "Unallocated":
      return "Unallocated";

    case "F":
      return "Failed";

    case "Q":
      return "Queued";

    case "S":
      return "Sent";

    case "H":
      return "On Hold";

    case "O":
      return "Open"; 

    default:
      return this;
  }
};

String.prototype.lpad = function (padString, length) {
  var str = this;
  while (str.length < length) str = padString + str;
  return str;
};

String.prototype.toFriendlyDateTimeString = function () {
  if (this == null || this == "" || this == undefined) {
    return "";
  }
  return new Date(this).toFriendlyDateTimeString();
};

String.prototype.toFriendlyDBDateTimeString = function () {
  if (this == null || this == "" || this == undefined) {
    return "";
  }
  return new Date(this).toFriendlyDBDateTimeString();
};

String.prototype.toProperCase = function () {
  return this.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

String.prototype.dateWithOffset = function () {
  return new Date(
    new Date(this).setMinutes(
      new Date(this).getMinutes() - new Date(this).getTimezoneOffset()
    )
  );
};

String.prototype.toSaveDateObject = function () {
  return new Date(new Date(this).toSaveDate());
};

String.prototype.toKebabCase = function () {
  return (
    this &&
    this.match(
      /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
    )
      .map((x) => x.toLowerCase())
      .join("-")
  );
};
